import { render, staticRenderFns } from "./MesaNewTrocarMesaComanda.vue?vue&type=template&id=24568bf6&scoped=true"
import script from "./MesaNewTrocarMesaComanda.vue?vue&type=script&lang=js"
export * from "./MesaNewTrocarMesaComanda.vue?vue&type=script&lang=js"
import style0 from "./MesaNewTrocarMesaComanda.vue?vue&type=style&index=0&id=24568bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24568bf6",
  null
  
)

export default component.exports